import request from '@/utils/request'

// Po Detail Head
export function getPoDetail(param) {
  let data = param
  return request({
    url: `/po/epms4010/getPoDetail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// Po Detail Grid
export function getPoDetailGrid(param) {
  let data = param
  return request({
    url: `/po/epms4010/getPoDetailGrid`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}